import { useContext } from "react";
import { StatusContext, TurnContext } from "../battle/Battle";

import styled, { keyframes } from "styled-components";
import icons from '../../assets/sprite.svg';

const StyledBattleLog = styled.div`
    border-radius: 15px;
    padding: 8px;
    margin: 5px 0;
    box-shadow: 9px 9px 16px rgba(189, 189, 189, 0.6),
        -9px -9px 16px rgba(255, 255, 255, 0.5);
`;

const BattleLogOuter = styled.div`
    display: flex;
    width: 550px;
    border-radius: 10px;
    box-shadow: inset 10px 10px 15px -10px #c3c3c3,
        inset -10px -10px 15px -10px #ffffff;
`;

const BattleLogInner = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    flex: 1;
`;

const appear = keyframes`
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`;

const AnimatedMessage = styled.span`
    margin: 0 auto;
    white-space: pre-line;
    display: inline-block;
    animation: ${appear} 400ms linear;
`;

const Icon = styled.svg`
    width: 40px;
    height: 40px;
    margin: 5px;
    fill: darkslategray;
`;

const BattleLog = () => {
    const status = useContext(StatusContext);
    const isPlayerTurn = useContext(TurnContext);

    const renderMessage = () => {
        if(status === 'init') return isPlayerTurn ? 'Your turn first.' : 'Enemy\'s turn first.';
        if(status === 'missed') {
            return isPlayerTurn ? 'Enemy missed. You are shooting.' : 'You missed. The enemy is shooting.';
        } else {
            return isPlayerTurn ? `Congratulation! The enemy ship was ${status}.\nYou are shooting again.` 
                        : `Your ship was ${status}. The enemy is shooting again.`;
        }
    }

    const message = renderMessage();

    return (
        <StyledBattleLog>
            <BattleLogOuter>
                <BattleLogInner>
                    <Icon>
                        <use href={`${icons}#battle`}/>
                    </Icon>
                    <AnimatedMessage key={message}>
                        {message}
                    </AnimatedMessage>
                    <Icon>
                        <use href={`${icons}#log`}/>
                    </Icon>
                </BattleLogInner>
            </BattleLogOuter>
        </StyledBattleLog>
    );
}

export default BattleLog;